import util from '../lib/util';
import * as consts from '../constants';

export default (state = {}, action) => {
    switch (action.type) {
        case 'INITIALIZE_STORE_NEWGASLINE':
            return {
                ...state,
                pageName: consts.NEW_GAS_LINE_NAME,
                checkConfirmAddress: 0, // default confirm address    
                unitNumber: "",
                //addressList: 0, // default selected address
                duplexMeterCount: "1",
                duplexSecondMeterLocation: "1",
                customerType: "1",//resident
                fortisBCAccount: 2,//no fortisBC Account
                billingAddress: "1", //same as service address:It will not change, because billing address and method removed and always for abandonment we will send the service address for billing address
                projectNotificationsEmail_IsSame: 1, //notification Email is same as user's email
                idType: "1", //Id type default is driving Licence     
                secondAccountContactAddress: "1",
                createProfileSelectOption: 2,
                workSiteContact: 1,
                addressList: null,
                ["Large trees"]: "0",
                ["Ditches"]: "0",
                ["Retaining walls"]: "0",
                ["Septic tanks"]: "0",
                ["Oil tanks"]: "0",
                ["Other"]:"",               
                gasDeliveryPressure :"1"
            };
        case 'INITIALIZE_STORE_SERVICEREMOVAL':
            return {
                ...state,
                pageName: consts.SERVICE_REMOVAL_NAME,
                unitNumber: "",
                customerType: "1",//resident
                fortisBCAccount: 2,//no fortisBC Account
                billingAddress: "1", //same as service address:It will not change, because billing address and method removed and always for abandonment we will send the service address for billing address
                projectNotificationsEmail_IsSame: 1, //notification Email is same as user's email
                idType: "1", //Id type default is driving Licence
                checkConfirmAddress: 0, // default confirm address
                addressList: 0, // default selected address
                reasonType: 1, // default reason demolish
                checkConfirm: 0,
                createProfileSelectOption: 2,
                workSiteContact: 1
            };
        case 'RESET_FORGOT_PASSWORD':
            return {
                ...state,
                email: '',
                forgotPasswordAgree: 0,
            };
        case 'RESET_UPDATE_EMAIL':
            return {
                ...state,
                profileEmailAddress: '',
                agreeEmail: 0,
            };
        case 'INITIALIZE_DASHBOARD':
            return {
                ...state,
                dashboardFilterByType: 'All',
                dashboardFilterByStatus: 'All',
                dashboardFilterByCity: 'All',
                dashboardSortBy: 'None',
            };
        case 'INITIALIZE_FORGOTPASSWORD':
            return {
                ...state,
                email: null,
                forgotPasswordAgree: 0
            };
        case 'INITIALIZE_LOGIN':
            return {
                ...state,
                password: null
            };
        case 'INITIALIZE_RESETPASSWORD':
            return {
                ...state,
                password: null,
                password_2: null

            };
        case 'INITIALIZE_PROFILE':
            return {
                ...state,
                profilePassword: null,
                profilePassword_2: null,
                agreeEmail: 0,
                agreeBillingInfo: 0
            };
        case 'INITIALIZE_PROJECTDETAILS':
            return {
                ...state,
                emailToAdd: null
            };
        case 'INITIALIZE_REGISTER':
            return {
                ...state,
                profileEmailAddress: null,
                profileEmailAddress_2: null,
                profileUserId: null,
                profilePassword: null,
                profilePassword_2: null,
                profileNotificationEmail: 0,
                profileUpdatesEmail: 0,
                bupaVerified: false,
                accountNumber: null
            };

        case 'INITIALIZE_STORE':
            return {
                ...{}
            };
        case 'INITIALIZE_STORE_BILLINGINFO':
            return {
                ...state,
                accountBillingAddress: action.model.mailingAddress.isPoBox ? "2" : "3",
                accountEmailAddress: action.model.sapEmail,
                accountPhoneContact_primaryPhone: util.formatPhoneNumber(action.model.primaryPhone),
                accountPhoneContact_primaryPhone_ext: action.model.primaryPhoneExt,
                accountPhoneContact_secondaryPhone: util.formatPhoneNumber(action.model.secondaryPhone),
                accountPhoneContact_secondaryPhone_ext: action.model.secondaryPhoneExt,
                accountPhoneContact_primaryCellPhone: util.formatPhoneNumber(action.model.primaryCellPhone),
                accountPhoneContact_primaryCellPhone_ext: action.model.primaryCellPhoneExt,
                accountPhoneContact_secondaryCellPhone: util.formatPhoneNumber(action.model.secondaryCellPhone),
                accountPhoneContact_secondaryCellPhone_ext: action.model.secondaryCellPhoneExt,
                accountBillingAddress_address_unitNumber: action.model.mailingAddress.unitNumber,
                accountBillingAddress_address_streetNumber: action.model.mailingAddress.streetNumber,
                accountBillingAddress_address_streetName: action.model.mailingAddress.streetName,
                accountBillingAddress_address_streetType: action.model.mailingAddress.streetType,
                accountBillingAddress_address_streetDirection: action.model.mailingAddress.streetDirection,
                accountBillingAddress_address_city: action.model.mailingAddress.city,
                accountBillingAddress_address_province: action.model.mailingAddress.province,
                accountBillingAddress_address_zip: action.model.mailingAddress.postCode,
                accountBillingAddress_address_country: action.model.mailingAddress.country,
                accountBillingAddress_poBox_poBox: action.model.mailingAddress.poBox,
                accountBillingAddress_poBox_city: action.model.mailingAddress.city,
                accountBillingAddress_poBox_state: action.model.mailingAddress.province,
                accountBillingAddress_poBox_postalCode: action.model.mailingAddress.postCode,
                accountBillingAddress_poBox_country: action.model.mailingAddress.country,
            };
        case 'radio':
        case 'checkbox':
        case 'select':
        case 'textbox':
            return { ...state, [action.name]: action.value, errors: { ...state.errors, [action.name]: null } };
        case 'DATE_SELECTED':
            return { ...state, isCustomerSpecifiedDate: 0, errors: { ...state.errors, noDateSelected: null } };
        case 'DATE_UNSELECTED':
            return { ...state, errors: { ...state.errors, noDateSelected: null } };
        case 'FORM_ERROR':
            return { ...state, errors: { ...state.errors, [action.name]: action.error } };
        case 'BUPA_VERIFIED': {
            const m = action.model.bpModel;
            let billingMethod = m.billingMethod ? m.billingMethod : state.billingMethod;
            if (state.pageName == consts.SERVICE_REMOVAL_NAME)
                billingMethod = "";
            let projectEmailData = {};
            if (!state.projectNo) {
                projectEmailData = {
                    projectNotificationsEmail_IsSame: (m.projectEmail == null ? 1 : 0),
                    projectNotificationsEmail: m.projectEmail,
                    projectNotificationsEmail_2: m.projectEmail,
                };
            }
            let customerType = "1";
            if (m.isBusiness)
                customerType = "2";
            else if (m.isBuilder)
                customerType = "3";
           
           
             return {
                ...state,
                bupaVerified: true,
                accountHolderInfo_residentInfo_firstName: m.firstName,
                accountHolderInfo_residentInfo_lastName: m.lastName,
                accountHolderInfo_residentInfo_dob: m.dob,
                accountHolderInfo_businessInfo_businessName: m.businessName,
                accountHolderInfo_phoneContact_primaryPhone: util.formatPhoneNumber(m.primaryPhone),
                accountHolderInfo_phoneContact_primaryPhone_ext: m.primaryPhoneExt,
                accountHolderInfo_phoneContact_secondaryPhone: util.formatPhoneNumber(m.secondaryPhone),
                accountHolderInfo_phoneContact_secondaryPhone_ext: m.secondaryPhoneExt,
                accountHolderInfo_phoneContact_primaryCellPhone: util.formatPhoneNumber(m.primaryCellPhone),
                accountHolderInfo_phoneContact_primaryCellPhone_ext: m.primaryCellPhoneExt,
                accountHolderInfo_phoneContact_secondaryCellPhone: util.formatPhoneNumber(m.secondaryCellPhone),
                accountHolderInfo_phoneContact_secondaryCellPhone_ext: m.secondaryCellPhoneExt,
                billingMethod,
                billingAddress: (m.address.isPoBox ? "2" : "3"),//TODO:When to choose 1(Same as service address)
                billingAddress_poBox_poBox: m.address.poBox,
                billingAddress_poBox_city: m.address.city,
                billingAddress_poBox_country: m.address.country,
                billingAddress_poBox_state: m.address.province,
                billingAddress_poBox_postalCode: m.address.postCode,
                billingAddress_address_unitNumber: m.address.unitNumber,
                billingAddress_address_streetNumber: m.address.streetNumber,
                billingAddress_address_streetName: m.address.streetName,
                billingAddress_address_streetType: m.address.streetType,
                billingAddress_address_streetDirection: m.address.streetDirection,
                billingAddress_address_city: m.address.city,
                billingAddress_address_state: m.address.province,
                billingAddress_address_zip: m.address.postCode,
                billingAddress_address_country: m.address.country,
                emailAddress: m.email,
                emailAddress_2: m.email,
                ...projectEmailData,
                customerType,
            };
        }
        case 'PROJECT_DETAIL_RECEIVED': {
            return { ...state, ...action.formModel };
        }
        case 'PARCEL': {
            if (action.parcel && action.parcel.addressList.length > 2)
                return { ...state, addressList: -2 };
            else
                return { ...state, addressList: 0 };
        }
        case 'SET_ADDRESS':
            {
                const name = action.name;
                const address = action.address;
                return {
                    ...state,
                    [name + '_unitNumber']: address.unitNumber,
                    [name + '_streetNumber']: address.streetNumber,
                    [name + '_streetName']: address.streetName,
                    [name + '_streetType']: address.streetType ? address.streetType : '',
                    [name + '_streetDirection']: address.streetType ? address.streetDirection : '',
                    [name + '_city']: address.city,
                    [name + '_country']: address.country,
                    [name + '_state']: address.province,
                    [name + '_zip']: address.postCode,
                };
            }
        case "MORE_CONTACT_PERSON":
            {
                if (action.newContactId) {
                    const id = action.newContactId;
                    return {
                        ...state,
                        moreContactPersonIds: action.moreContactPersonIds,
                        [`aditionalContactPerson${id}Address`]: "1"
                    };
                }
                else
                    return { ...state, moreContactPersonIds: action.moreContactPersonIds };
            }
        case 'CONTACT_SAVED_SUCCESS':
            return { ...state, [`${action.name}Saved`]: true };
        default:
            return state;
    }
};